import React from 'react';

import { Conteiner } from './styles'

export default function({text}) {
    return (
        <Conteiner>{text}</Conteiner>
    )
}